// src/data/fallbacks.ts
const modules = import.meta.glob('@data/examples/*.json', { eager: true })

type JsonModule = {
  default: any
}

// 自动生成所有 JSON 数据的 fallback
export const fallbackData = Object.entries(modules).reduce((acc, [path, module]) => {
  const key = path.replace(/^.*\/(.*)\.json$/, '$1').replace(/-/g, '')
  acc[key] = (module as JsonModule).default
  return acc
}, {} as Record<string, any>)
